import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { getList } from "../../../../../services/api/Api.js";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import "./FilterSelect.less";
import { isActivePublicUser } from "../../../../../util/Scripts.js";
import { Message, Spin } from "../../../../BP2Components";
import { getListV3 } from "../../../../../services/restAPI/ListsV2";

const { Option, OptGroup } = Select;

const FilterSelect = ({ connections, elements, setSettings }) => {
   const intl = useIntl();
   const [widgetsColumns, setWidgetsColumns] = useState([]);

   const { sheets } = useSelector(({ boards }) => boards.currentBoard);

   const handleInitialValues = (fieldTechName) => {
      const fieldValues = connections
         ?.find((connection) => connection.fieldTechName === fieldTechName)
         ?.filteredColumnTechNames?.split(";");
      return fieldValues?.length && fieldValues[0] !== "" ? fieldValues : undefined;
   };

   const handleChange = (techName) => (columnTechnames) => {
      setSettings((prevSettings) => {
         const { connections } = prevSettings;
         const connectionsTable = Array.isArray(connections) ? [...connections] : [];
         const connectionIdx = connectionsTable.findIndex(
            (connection) => connection.fieldTechName === techName,
         );
         const filteredColumnTechNames = (columnTechnames || []).join(";");
         if (!filteredColumnTechNames) {
            if (connectionIdx >= 0) connectionsTable.splice(connectionIdx, 1);
            return { ...prevSettings, connections: connectionsTable };
         }
         const payload = {
            fieldTechName: techName,
            filteredColumnTechNames: filteredColumnTechNames,
         };
         if (connectionIdx >= 0) connectionsTable[connectionIdx] = payload;
         else connectionsTable.push(payload);
         return { ...prevSettings, connections: connectionsTable };
      });
   };

   const fetchColumns = async (widgetsToFetchColumnsFrom) => {
      try {
         if (!widgetsToFetchColumnsFrom?.length) {
            Message.info(intl.formatMessage({ id: "filterWidget.noWidgetsToFetchInfoFrom" }));
            return;
         }

         const listColumns = {};
         await Promise.all(
            widgetsToFetchColumnsFrom.map(async (widgetSettings) => {
               const listId = widgetSettings.listWidgetSeries?.[0]?.listId ?? widgetSettings.listId;
               if (!listId) {
                  console.warn("FilterSelect: widget without listId skipped", widgetSettings?.id);
                  return;
               }
               const idStr = String(listId);
               const isV3 = idStr.length > 10;
               const res = await (isV3 ? getListV3(listId, 1, 1) : getList(listId, 1, 1));
               const responseData = isActivePublicUser()
                  ? res?.data?.getPublicList
                  : (res?.data?.default ?? res?.data);
               listColumns[
                  `${responseData?.meta?.name ?? responseData?.meta?.id}-${listId}|${widgetSettings.id}`
               ] = responseData?.columns;
            }),
         );

         setWidgetsColumns(listColumns);
      } catch (_err) {
         Message.error(intl.formatMessage({ id: "settings.errorWhileFetchingList" }));
      }
   };

   useEffect(() => {
      if (sheets?.length > 0) {
         const acceptedWidgets = sheets.map((sheet) =>
            sheet.widgets.filter(
               (widget) =>
                  widget.name === "list" ||
                  widget.name === "advertisementList" ||
                  widget.name === "productItem" ||
                  widget.name === "kanban",
            ),
         );
         const widgetsToFetchColumnsFrom = [].concat(...acceptedWidgets);
         fetchColumns(widgetsToFetchColumnsFrom);
      }
   }, [sheets]);
   return (
      <ul className="filter-select">
         {Object.keys(widgetsColumns)?.length ? (
            elements?.map(
               (element) =>
                  element?.hidden !== "1" && (
                     <li key={element?.tech_name} className="filter-select__item">
                        <p className="filter-select__item__label">{element?.label}</p>
                        <Select
                           showSearch
                           mode="multiple"
                           className="filter-select__item__select"
                           onChange={handleChange(element?.tech_name ?? element?.id)}
                           defaultValue={handleInitialValues(element?.tech_name ?? element?.id)}
                           optionFilterProp="children"
                        >
                           {Object.keys(widgetsColumns)?.map((widgetKey) => (
                              <OptGroup label={widgetKey?.split("|")?.[0]} key={widgetKey}>
                                 {widgetsColumns[widgetKey]?.map((column) => (
                                    //TODO: Change value to techname after backend implements new filtering
                                    <Option
                                       key={column?.techName ?? column?.label}
                                       value={`${(widgetKey || "").split("|")[1] ?? ""}|${column?.options?.techName ?? column?.techName ?? ""}`}
                                    >
                                       {column?.label}
                                    </Option>
                                 ))}
                              </OptGroup>
                           ))}
                        </Select>
                     </li>
                  ),
            )
         ) : (
            <Spin className="spin-middle" />
         )}
      </ul>
   );
};

FilterSelect.propTypes = {
   elements: PropTypes.arrayOf(PropTypes.object).isRequired,
   setSettings: PropTypes.func.isRequired,
};

export default FilterSelect;
